import React from 'react'
import classnames from 'classnames'
import './grid.css'

const Grid = ({ small = false, medium = true, large = false, className, children }) => (
  <div
    className={
      classnames({
        'grid': true,
        'grid--small': small,
        'grid--medium': medium && !small && !large,
        'grid--large': large,
        [className]: className,
      })
    }
  >
    {children}
  </div>
)


export default Grid


// WEBPACK FOOTER //
// ./src/ui/grid/index.jsx